import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectGenerateContentModalData, textureDetailsModalActions } from "../../redux/slicers/textureDetailsModalSlicer";
// import { createModelAutomationRender, wait } from "../../helpers/jsHelper";
import GenerateContentPopup from "../../common/Textures/GenerateContentPopup";
import { UploadTextureModelSelect } from "../UploadTextureModelSelect";
import { Mixpanel, MxEvent } from "../../common/Mixpanel";
import { setGenerateVisualModal } from "../../redux/slicers/productV2Slicer";

export const GenerateContentModal = ({ refetchList, _showApplyTextureModal = false, _setShowApplyTextureModal, hideProductInfoAction, hideTextureInfoAction}) => {
    const [showApplyTextureModal, setShowApplyTextureModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const generateContent = useSelector(selectGenerateContentModalData);
    const dispatch = useDispatch();

    let isTexture = 'is_special_case_texture' in (generateContent ?? {});
    if (!isTexture) {
        isTexture = Boolean(generateContent?.texture_file || generateContent?.low_texture_file)
    }
    const isModel = !isTexture || (generateContent?.blender_id || generateContent?.is_prop_group || generateContent?.product_file)

    const onClose = () => {
        dispatch(textureDetailsModalActions.closeGenerateContentShowModal());
    };

    useEffect(() => {
        if (_showApplyTextureModal?.id)
            {
                setShowApplyTextureModal(_showApplyTextureModal)
                _setShowApplyTextureModal(false)
            }
    }, [_showApplyTextureModal?.id])

    const onContentCreate = async () => {
        Mixpanel.track(true, MxEvent.CLICK_GENERATE_VISUAL);
        if (isModel) {
            // setLoading(true)
            // await createModelAutomationRender({ data: generateContent });
            // setLoading(false)
        dispatch(setGenerateVisualModal(generateContent))
        }
        else
            setShowApplyTextureModal(generateContent);
        dispatch(textureDetailsModalActions.closeGenerateContentShowModal());
    }

    return <>
        <GenerateContentPopup data={generateContent} show={Boolean(generateContent)} onClose={onClose} onContentCreate={onContentCreate} btnLoading={loading} {...{hideProductInfoAction, hideTextureInfoAction}}/>
        <UploadTextureModelSelect
            uploadedFiles={[showApplyTextureModal]}
            showApplyTextureModal={showApplyTextureModal}
            setShowApplyTextureModal={setShowApplyTextureModal}
            onSuccess={refetchList}
        />
    </>
};